import { InjectionToken, inject } from '@angular/core';
import { WINDOW } from './window';

export const NAVIGATOR = new InjectionToken('tvd.navigator', {
  factory: () => {
    const nav = inject(WINDOW).navigator;
    if (!nav) {
      throw new Error('Navigator is not available current context');
    }

    return nav;
  },
});
